import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable, of, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {observe} from 'projects/web/src/util/loading/loading';
import {Host} from '@interfaces/host';
import {HostCompanyService} from '../host-company.service';
import {CompanyService} from '../company.service';

@Injectable({
  providedIn: 'root'
})
export class HostCompanyIdWithCompanyClosingsResolverService implements Resolve<Host.ReducedCompany> {
  constructor(private companyService: HostCompanyService,
              private sessionCompany: CompanyService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Host.ReducedCompany> {
    return observe(this.companyService.getCompanyWithCompanyClosings().pipe(
      catchError((error) => {
        if (!state.url.includes('/availability')) return throwError(error);
        console.error('Ruby company/reduced failed while opening availability', error);
        const fallback = this.companyFromSession();
        return fallback ? of(fallback) : throwError(error);
      })
    ));
  }

  private companyFromSession(): Host.ReducedCompany | null {
    try {
      const stored = this.sessionCompany.loadFromStorage();
      if (!stored?.id) return null;
      return {
        id: stored.id,
        company_closings: stored.company_closings || [],
        languages: stored.languages || [],
      };
    } catch (error) {
      console.error('Unable to read the company saved at login', error);
      return null;
    }
  }
}
